// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductCatalogQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.ProductFilter>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ProductCatalogQuery = { __typename?: 'Query', productsPage: { __typename?: 'ProductsPage', products: Array<{ __typename?: 'Product', id: string, name: string, sku?: string | null | undefined, upc?: string | null | undefined, attributes: Array<{ __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType }>, status: { __typename?: 'ProductStatusDetail', code: Types.ProductStatus, name: string }, images: Array<{ __typename?: 'Asset', id: string, url: string, downloadUrl: string, contentType: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type ProductCatalogDetailsFragment = { __typename?: 'Product', id: string, name: string, sku?: string | null | undefined, upc?: string | null | undefined, attributes: Array<{ __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType }>, status: { __typename?: 'ProductStatusDetail', code: Types.ProductStatus, name: string }, images: Array<{ __typename?: 'Asset', id: string, url: string, downloadUrl: string, contentType: string }> };

export const ProductCatalogDetailsFragmentDoc = gql`
    fragment ProductCatalogDetails on Product {
  id
  name
  attributes(type: [BRAND, FINISH]) {
    id
    value
    type
  }
  sku
  upc
  status {
    code
    name
  }
  images {
    id
    url
    downloadUrl
    contentType
  }
}
    `;
export const ProductCatalogDocument = gql`
    query ProductCatalog($first: Int, $filter: ProductFilter, $offset: Int) {
  productsPage(first: $first, filter: $filter, offset: $offset) {
    products {
      ...ProductCatalogDetails
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${ProductCatalogDetailsFragmentDoc}`;

/**
 * __useProductCatalogQuery__
 *
 * To run a query within a React component, call `useProductCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProductCatalogQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(ProductCatalogDocument, options);
      }
export function useProductCatalogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(ProductCatalogDocument, options);
        }
export function useProductCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductCatalogQuery, ProductCatalogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductCatalogQuery, ProductCatalogQueryVariables>(ProductCatalogDocument, options);
        }
export type ProductCatalogQueryHookResult = ReturnType<typeof useProductCatalogQuery>;
export type ProductCatalogLazyQueryHookResult = ReturnType<typeof useProductCatalogLazyQuery>;
export type ProductCatalogSuspenseQueryHookResult = ReturnType<typeof useProductCatalogSuspenseQuery>;
export type ProductCatalogQueryResult = Apollo.QueryResult<ProductCatalogQuery, ProductCatalogQueryVariables>;